import { useMutation, useQueryClient } from "@tanstack/react-query";

import { useDomainServices } from "@/providers/DomainServices";

import {
  MetricDefinitionRecord,
  UpdateMetricDefinitionRequest,
} from "../MetricRecord";

import { metricsQueryKeys } from "./metricsQueryKeys";

interface Params {
  name: string;
  request: UpdateMetricDefinitionRequest;
  orgId?: string;
}

export function useUpdateMetricDefinition() {
  const { metricsService } = useDomainServices();
  const queryClient = useQueryClient();

  return useMutation<MetricDefinitionRecord, Error, Params>({
    mutationFn: ({ name, request, orgId }) =>
      metricsService.updateMetricDefinition(name, request, { orgId }),
    onSuccess: (record) => {
      void queryClient.invalidateQueries({
        queryKey: metricsQueryKeys.definitions(),
      });
      queryClient.setQueryData(
        metricsQueryKeys.definition(record.name, record.org_id),
        record,
      );
    },
  });
}
